import store from '@/states/index.js'

import SupplierCompanyProfile from '../SupplierCompanyProfile'

export default [
    {
        path: '/supplier_company_profile',
        component: SupplierCompanyProfile,
        name: 'supplier_company_profile',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 2){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]